import React from 'react';
import Layout from '../global/Layout';
import * as Styled from './SeminarPage.styles';
import { useKirbyDemoContent } from '../../hooks/useKirbyData';
import { useTranslation } from 'react-i18next';

interface SeminarPageProps {
  url: string;
  title: string;
}

const SeminarPage: React.FC<SeminarPageProps> = ({ title, url }) => {
  const { i18n } = useTranslation();
  // i18n.language; // subscribe (or use it in JSX)
  const { data: demoContent } = useKirbyDemoContent();

  let height = "400";

  if (demoContent.online_demo_iframe_show && demoContent.online_demo_iframe_url) {
    const params = new URLSearchParams(demoContent.online_demo_iframe_url.split('?')[1]);
     height = params.get('size');
  }

  console.log(height)

  return (
    <Layout showSidebar>
      <h1>{demoContent.online_demo_title ? demoContent.online_demo_title : title}</h1>
      {demoContent.online_content_show && demoContent.online_content && (
        <Styled.Content dangerouslySetInnerHTML={{ __html: demoContent.online_content }} />
      )}
      {demoContent.online_demo_iframe_show && demoContent.online_demo_iframe_url && (
        // <Styled.Content dangerouslySetInnerHTML={{ __html: demoContent.online_content }} />
        <Styled.IFrame height={height} title='SOLID Seminare' src={demoContent.online_demo_iframe_url} />
      )}
    </Layout>
  );
};

export default SeminarPage;
